import { Type } from '@sinclair/typebox';
import { SupportedNetworkSchema } from './supported-network.js';
import { ExtendedTokenMetaSchema, TokenSocailsSchema, } from './token/token-meta-extended.js';
export const TrendingTiersObject = {
    noTier: 'no-tier',
    gold1: 'gold-1',
    gold2: 'gold-2',
    gold3: 'gold-3',
    platinum1: 'platinum-1',
    platinum2: 'platinum-2',
    platinum3: 'platinum-3',
    diamond1: 'diamond-1',
    diamond2: 'diamond-2',
    diamond3: 'diamond-3',
    finalElite: 'elite',
};
export const TrendingTiers = Type.Enum(TrendingTiersObject);
export const UnionPremiumTypePurchase = Type.Union([Type.Literal('premium'), Type.Literal('boosters')], {
    description: 'Premium or Boosters type purchase',
    type: 'string',
    enum: ['premium', 'boosters'],
});
export var IPremiumStatus;
(function (IPremiumStatus) {
    IPremiumStatus["Active"] = "active";
    IPremiumStatus["Processing"] = "processing";
    IPremiumStatus["Inactive"] = "inactive";
    IPremiumStatus["Archived"] = "archived";
    IPremiumStatus["Expired"] = "expired";
    IPremiumStatus["Failed"] = "failed";
})(IPremiumStatus || (IPremiumStatus = {}));
export const EnumPremiumStatus = Type.Union(Object.values(IPremiumStatus).map((status) => Type.Literal(status)));
export const PremiumInitiatePurchaseSchema = Type.Object({
    tokenAddress: Type.String({
        description: 'Token address which passed safety-check',
    }),
    network: SupportedNetworkSchema,
    walletAddress: Type.Optional(Type.String({
        description: 'Wallet address from which the purchase will be made',
    })),
    type: UnionPremiumTypePurchase,
    boostersAmount: Type.Number({
        description: 'Amount of boosters to purchase',
    }),
});
export const PremiumInitiatePurchaseResponseSchema = Type.Object({
    verificationId: Type.String({
        description: 'Verification ID for the initiated purchase - originally premiumId',
    }),
    depositWalletAddress: Type.String({
        description: 'Deposit wallet address for manual transfer',
    }),
});
export const PremiumMetaSchema = Type.Object({
    premiumId: Type.String(),
    premium: Type.Boolean({
        description: 'Premium status',
    }),
    status: EnumPremiumStatus,
    ownerDelugeId: Type.Optional(Type.String()),
    ownerUsername: Type.Optional(Type.String()),
    ownerAvatarSrc: Type.Optional(Type.String()),
    portalLink: Type.Optional(Type.String()),
    logo: Type.Optional(Type.String({
        description: 'Premium logo image path (overrides token logo while premium is active)',
    })),
    banner: Type.Optional(Type.String({
        description: 'Premium banner image path',
    })),
    boosters: Type.Number(),
    splashPoints: Type.Optional(Type.Number()),
    tier: Type.Optional(TrendingTiers),
    trendingEmojiIds: Type.Optional(Type.Object({
        static: Type.Optional(Type.String()),
        animated: Type.Optional(Type.String()),
    })),
    expiresAt: Type.String(),
    purchaseTxHash: Type.Optional(Type.String({
        description: 'Tx hash of the most recent premium purchase',
    })),
    socials: Type.Optional(TokenSocailsSchema),
    archivedPremiums: Type.Optional(Type.Array(Type.Object({
        premiumId: Type.String(),
        status: Type.Union([
            Type.Literal(IPremiumStatus.Archived),
            Type.Literal(IPremiumStatus.Expired),
            Type.Literal(IPremiumStatus.Failed),
        ]),
        archivedAt: Type.String(),
        reason: Type.String(),
        note: Type.Optional(Type.String()),
        expiresAt: Type.String(),
        logo: Type.Optional(Type.String()),
        imageHash: Type.Optional(Type.String()),
        banner: Type.Optional(Type.String()),
        socials: Type.Optional(TokenSocailsSchema),
        portalLink: Type.Optional(Type.String()),
        ownerDelugeId: Type.Optional(Type.String()),
        ownerUsername: Type.Optional(Type.String()),
        ownerAvatarSrc: Type.Optional(Type.String()),
    }))),
    updatedAt: Type.String(),
});
export const TokenMetaWithPremiumSchema = Type.Intersect([
    ExtendedTokenMetaSchema,
    Type.Object({
        premium: PremiumMetaSchema,
    }),
], { title: 'TokenMetaWithPremiumSchema' });
export const TokenMetasWithPremiumSchema = Type.Array(TokenMetaWithPremiumSchema);
export const VerifyPurchaseSchema = Type.Object({
    verificationId: Type.String(),
    portalLink: Type.String(),
    network: SupportedNetworkSchema,
    walletAddress: Type.Optional(Type.String()),
    signature: Type.Optional(Type.String()),
    type: UnionPremiumTypePurchase,
});
export const ExtendAndVerifyPremiumPurchaseSchema = Type.Object({
    premiumId: Type.String(),
    network: SupportedNetworkSchema,
    signature: Type.Optional(Type.String()),
    walletAddress: Type.Optional(Type.String()),
});
export const PremiumGetTokenInfoSchema = Type.Object({
    tokenAddress: Type.String(),
    network: SupportedNetworkSchema,
});
export const PremiumUpdateInfo = Type.Object({
    logo: Type.Optional(Type.Any({
        description: 'Token Logo image base64',
    })),
    banner: Type.Optional(Type.Any({
        description: 'Banner image base64',
    })),
    trendingEmojiId: Type.Optional(Type.Any({
        description: 'Emoji ID from /preview-emoji',
    })),
    portalLink: Type.Optional(Type.String({
        description: 'Portal link',
    })),
    socials: Type.Optional(TokenSocailsSchema),
});
export const PremiumUpdateTokenMetaSchema = Type.Intersect([
    Type.Object({ premiumId: Type.String(), network: SupportedNetworkSchema }),
    PremiumUpdateInfo,
]);
//# sourceMappingURL=premium.js.map